export class WindowManager {
  private subscribers: Map<Action, SubscriberFn[]> = new Map();
  private window: Window | null = null;

  open(url: string) {
    const screenX = window.screenX;
    const screenY = window.screenY;
    const screenWidth = window.visualViewport?.width ?? 0;
    const screenHeight = window.visualViewport?.height ?? 0;
    const popupHeight = 860;
    const popupWidth = 660;

    const popupLeft = screenX + (screenWidth / 2 - popupWidth / 2);
    const popupTop = screenY + (screenHeight / 2 - popupHeight / 2);
    const windowFeatures = `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop}`;

    this.window = window.open(url, '_blank', windowFeatures);

    // There's no way to attach a close handler to the window so the only way seems to be to poll for the closed flag
    const interval = setInterval(() => {
      if (this.window?.closed) {
        clearInterval(interval);
        this.subscribers.get('close')?.forEach(callback => callback());
        this.window = null;
        return;
      }
    }, 500);

    this.subscribers.get('open')?.forEach(callback => callback());
  }

  close() {
    this.window?.close();
  }

  focus() {
    this.window?.focus();
  }

  on(action: Action, callback: SubscriberFn) {
    if (!this.subscribers.has(action)) {
      this.subscribers.set(action, []);
    }

    this.subscribers.get(action)?.push(callback);
  }
}

export const PopUpWindow = new WindowManager();

type Action = 'open' | 'close';
type SubscriberFn = () => void;
